import React, { useState } from 'react';

const Videos = () => {
  const [activeVideo, setActiveVideo] = useState(0);

  const playlist = [
    {
      id: "MMiCgIMxxmw",
      title: "Indian Media",
      channel: "Police News Plus",
      thumbnail: "https://img.youtube.com/vi/MMiCgIMxxmw/maxresdefault.jpg",
      description: "A look into the current state of Indian Media."
    },
    {
      id: "35EsSRob5I8",
      title: "Twitter has turned everyone into a reporter",
      channel: "Police News Plus",
      thumbnail: "https://img.youtube.com/vi/35EsSRob5I8/maxresdefault.jpg",
      description: "How social media platforms like Twitter are changing journalism."
    },
    {
      id: "ury5OJs181s",
      title: "Senior advocate RC Paul Kanagaraj inaugurated water tent",
      channel: "National Police News Plus",
      thumbnail: "https://img.youtube.com/vi/ury5OJs181s/maxresdefault.jpg",
      description: "This program was organised by Mr.Sham Narain, State Media Secretary of News Media Association of India."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      {/* Hero Section */}
      <section 
        className="relative bg-blue-900 text-white py-12 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/videos_banner.png')" }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Multimedia Gallery</h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Explore our collection of videos covering press events, media insights, and NAI activities
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Main Video Player */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="aspect-w-16 aspect-h-9 relative pb-[56.25%] bg-black">
                <iframe 
                  src={`https://www.youtube.com/embed/${playlist[activeVideo].id}?autoplay=1&rel=0`}
                  title={playlist[activeVideo].title}
                  className="absolute top-0 left-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  {playlist[activeVideo].title}
                </h2>
                <div className="flex items-center text-sm text-gray-500 mb-4">
                  <span className="font-semibold text-blue-600 mr-2">{playlist[activeVideo].channel}</span>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {playlist[activeVideo].description}
                </p>
              </div>
            </div>
          </div>

          {/* Playlist Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="p-4 border-b border-gray-100 bg-gray-50">
                <h3 className="text-lg font-bold text-gray-900">Up Next</h3>
              </div>
              <div className="divide-y divide-gray-100 max-h-[600px] overflow-y-auto">
                {playlist.map((video, index) => (
                  <div 
                    key={video.id}
                    onClick={() => setActiveVideo(index)}
                    className={`p-4 cursor-pointer transition-colors duration-200 hover:bg-blue-50 flex space-x-4 ${
                      activeVideo === index ? 'bg-blue-50 border-l-4 border-blue-600' : ''
                    }`}
                  >
                    <div className="flex-shrink-0 w-32 h-20 relative rounded-lg overflow-hidden bg-gray-200">
                      <img 
                        src={video.thumbnail} 
                        alt={video.title} 
                        className="w-full h-full object-cover"
                      />
                      {activeVideo === index && (
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                          <div className="w-8 h-8 rounded-full bg-white/90 flex items-center justify-center">
                            <span className="text-blue-600 text-xs">▶</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className={`text-sm font-semibold mb-1 line-clamp-2 ${
                        activeVideo === index ? 'text-blue-600' : 'text-gray-900'
                      }`}>
                        {video.title}
                      </h4>
                      <p className="text-xs text-gray-500">
                        {video.channel}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Additional Info Box */}
            <div className="mt-6 bg-blue-600 rounded-2xl p-6 text-white text-center">
              <h3 className="text-xl font-bold mb-2">Subscribe to our Channel</h3>
              <p className="text-blue-100 text-sm mb-4">
                Stay updated with the latest news and insights from the media world.
              </p>
              <a 
                href="https://www.youtube.com/@nationalpolicenewsplus690" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-white text-blue-600 font-bold py-2 px-6 rounded-full hover:bg-gray-100 transition-colors duration-200"
              >
                Visit Channel
              </a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Videos;
